

    document.addEventListener('DOMContentLoaded', function() {
        var calendarEl = document.getElementById('calendar');
        var calendar = new FullCalendar.Calendar(calendarEl, {
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
          initialView: 'listWeek',
          googleCalendarApiKey: 'AIzaSyA51QMm99Dc_56xfZJfcFG2ONf3KGVsbb4',
  events: {
    googleCalendarId: 'abelchristo113@gmail.com'
  }
  
        });
        calendar.render();
      });

      

     